import type { SxStyleFunc } from '@aibees/shared/theme';

export const root: SxStyleFunc<{
  isLoading: boolean;
  isPopover: boolean;
  isUpdatePage: boolean;
}> = ({ isLoading, isPopover, isUpdatePage: _isUpdatePage }) => ({
  p: (p) => {
    if (isPopover) return p.spacing(0.5);
    return 0;
  },
  width: (p) => (!isPopover ? '100%' : p.spacing(52.5)),
  maxHeight: (p) => (isLoading ? p.spacing(37.5) : undefined),
});
